import React, { Component, Suspense } from 'react';
import { Modal, ModalBody, ModalHeader, Button } from 'reactstrap'
import {
    Outlet,
} from 'react-router-dom';
import withRouter from './components/withRouter';

import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer } from 'react-toastify';
import { t } from 'i18next';

import LoadingSkeleton from './layout/Indicator/loading-skeleton'

import Aux from "../hoc/_Aux";
import ScrollToTop from './layout/ScrollToTop';
import { CLEAR_PROGRAM_DATA, GET_PROGRAM_DATA, SET_PORTAL_ERROR } from '../store/actions/dashboardAction';
import { GET_PORTAL_LOGO, SET_PORTAL_REDUCER_ERROR } from '../store/actions/portal';
import { SET_IS_USER_AUTHENTICATED, SET_LOGOUT_BY_USER, UN_AUTHORIZED_TROZEN_ACCESS } from '../store/actions/auth'
import { UN_AUTHORIZED_TROZEN_ACCESS_FOR_HOME_OFFICE, GET_PROGRAM_DATA_FOR_HOME_USER, SET_IS_USER_AUTHENTICATED_FOR_HOME_CUSTOMER } from '../store/actions/homeCustomer'
import { CLEAR_USER_GROUP_BY_USERID } from '../store/actions/user';

import AxiosHelper from '../helper/AxiosHelper'
import AxiosHomeCustomer from '../helper/AxiosHomeCustomer'
import versionChecker from '../helper/VersionChecker'

import AuthHomeCustomer from '../models/AuthHomeCustomer';
import { PORTAL_INSTANCE } from '..';
import LoadingOverlay2 from './layout/Indicator/loading-overlay2';
import Auth from '../models/Auth';
import WarningIssue from '../Pages/Commons/WarningIssue';
import SupportButton from '../helper/components/SupportButton';

const { connect } = require('react-redux')
const mapStateProps = (state) => {
    return {
        portalLogoName: state.portal.portalLogoName,
        selectedPortalLogo: state.portal.selectedPortalLogo,
        programError: state.allRequest.programError,
        portalError: state.portal.portalError,
        programData: state.allRequest.programData,
        notAllowedToEnter: state.auth.notAllowedToEnter,
        notAllowedToEnterHomeCustomerPortal: state.homeCustomer.notAllowedToEnterHomeCustomerPortal,
        isHomeUserAuthenticated: state.auth.isHomeUserAuthenticated
    }
}
const mapActionProps = {
    GET_PORTAL_LOGO: (payload) => GET_PORTAL_LOGO(payload),
    GET_PROGRAM_DATA: (payload) => GET_PROGRAM_DATA(payload),
    GET_PROGRAM_DATA_FOR_HOME_USER: (payload) => GET_PROGRAM_DATA_FOR_HOME_USER(payload),
    SET_PORTAL_ERROR: (message) => SET_PORTAL_ERROR(message),
    SET_PORTAL_REDUCER_ERROR: (message) => SET_PORTAL_REDUCER_ERROR(message),
    SET_IS_USER_AUTHENTICATED: (isAuthenticated) => SET_IS_USER_AUTHENTICATED(isAuthenticated),
    UN_AUTHORIZED_TROZEN_ACCESS: (isNotAllowedAlready) => UN_AUTHORIZED_TROZEN_ACCESS(isNotAllowedAlready),
    UN_AUTHORIZED_TROZEN_ACCESS_FOR_HOME_OFFICE: (isNotAllowedAlready) => UN_AUTHORIZED_TROZEN_ACCESS_FOR_HOME_OFFICE(isNotAllowedAlready),
    SET_IS_USER_AUTHENTICATED_FOR_HOME_CUSTOMER: (payload) => SET_IS_USER_AUTHENTICATED_FOR_HOME_CUSTOMER(payload),

    SET_LOGOUT_BY_USER: () => SET_LOGOUT_BY_USER(),
    CLEAR_PROGRAM_DATA: () => CLEAR_PROGRAM_DATA(),
    CLEAR_USER_GROUP_BY_USERID: () => CLEAR_USER_GROUP_BY_USERID(),
}

class App extends Component {
    constructor(props) {
        super(props);

        let { cId, pId } = PORTAL_INSTANCE
        this.state = {
            portalId: pId,
            clientId: cId,
            showRequireLogin: true,
            showWarning: false,
        }
        this.props.SET_IS_USER_AUTHENTICATED(true)
        this.props.SET_IS_USER_AUTHENTICATED_FOR_HOME_CUSTOMER(true)
    }
    get isHomeCustomer() {
        return PORTAL_INSTANCE.isHomeCustomer
    }
    get isPublicPaths() {
        const paths = [
            '/req-qr/login', '/req-qr/create/login', '/req-qr/edit/login', '/login',
            '/forgotpassword', '/forgotusername',
            '/terms', '/privacypolicy',
            '/home/portal-account-verify', '/home/samlredirect',
            '/helpService', '/completedQRCodeRequest', '/home/reset-password'
        ];
        const pathname = (this.props && this.props.location && this.props.location.pathname);
        if (pathname) {
            for (let l of paths) {
                if (pathname.indexOf(l) === 0) {
                    return true;
                }
            }
        }
        return false;
    }

    get isSignInRoute() {
        const pathname = (this.props && this.props.location && this.props.location.pathname) || '';
        if (pathname === '/login' || pathname === '/' || pathname === '/req-qr/login') return true;
        if (pathname.startsWith('/req-qr/create/login') || pathname.startsWith('/req-qr/edit/login')) return true;
        if (pathname.indexOf('/home-customer/login') !== -1) return true;
        return false;
    }

    async componentDidMount() {
        console.log('CP Portal started')
        Auth.subscribeTokenExpiry(async () => {
            console.log(`Subscription Token Expiry started.....`)
            if (Auth.token) {
                await this.props.SET_LOGOUT_BY_USER()
                this.props.CLEAR_PROGRAM_DATA()
                this.props.CLEAR_USER_GROUP_BY_USERID()
            }
            if (Auth.isUserSessionExpired) {
                console.log('User session is already expired!')
                Auth.isUserSessionExpired = false
                this.setState({ showWarning: true })
            }
            this.props.SET_IS_USER_AUTHENTICATED(false)
        })
        AxiosHelper.subscribeUnauthorizedAccess(() => {
            console.log(`Subscription started.....`)
            this.props.SET_IS_USER_AUTHENTICATED(false)
        })
        AxiosHelper.subscribeUnauthorizedTrozenAccess(() => {
            console.log(`Subscription started.....`)
            this.props.UN_AUTHORIZED_TROZEN_ACCESS(this.props.notAllowedToEnter)
        })

        //------------------Auth Home Customer TODO remove this?----------------------//
        AuthHomeCustomer.subscribeTokenExpiry(() => {
            this.props.SET_IS_USER_AUTHENTICATED_FOR_HOME_CUSTOMER(false)
        })
        AxiosHomeCustomer.subscribeUnauthorizedAccess(() => {
            console.log(`Subscription started.....`)
            this.props.SET_IS_USER_AUTHENTICATED_FOR_HOME_CUSTOMER(false)
        })
        AxiosHomeCustomer.subscribeUnauthorizedTrozenAccess(() => {
            console.log(`Subscription started.....`)
            this.props.UN_AUTHORIZED_TROZEN_ACCESS_FOR_HOME_OFFICE(this.props.notAllowedToEnterHomeCustomerPortal)
        })

        if (!(this.props.location.pathname.includes('home/samlredirect')) && !(this.state.portalId && this.state.clientId)) {
            return this.redirectUrl('/notfound')
        }

        if (this.isHomeCustomer) {
            if (PORTAL_INSTANCE.authInst.isUserAuthenticated) {
                this.props.SET_IS_USER_AUTHENTICATED_FOR_HOME_CUSTOMER(true)
            } else if (window.location.pathname.indexOf('/login') === -1) {
                this.doLogout()
            }
        } else {
            if (this.isPublicPaths) {
                console.log('User access the public address')
            } else {
                if (PORTAL_INSTANCE.authInst.isUserAuthenticated) {
                    console.log('User already logged in or session still valid')
                } else if ((window.location.pathname.indexOf('/login') === -1)) {
                    this.doLogout()
                } else {
                    console.log('That is fairly!')
                }
            }
        }

        const { GET_PROGRAM_DATA, GET_PROGRAM_DATA_FOR_HOME_USER } = this.props

        if (!this.props.programData || !Object.keys(this.props.programData).length || (this.props.programData["id"] !== this.state.portalId)) {
            if (this.isHomeCustomer) {
                await GET_PROGRAM_DATA_FOR_HOME_USER({ portalId: this.state.portalId, clientId: this.state.clientId })
            } else {
                await GET_PROGRAM_DATA({ portalId: this.state.portalId, clientId: this.state.clientId });
            }

            if (this.props.programError) {
                console.log(`portal Error Occurred :`, this.props.programError)
                this.props.SET_PORTAL_ERROR(null);
                return;
            }
        }

        // Start version checking for deployment updates
        versionChecker.startPeriodicCheck(3); // Check every 3 minutes
    }

    componentDidUpdate() {
        console.log('App componentDidUpdate')
    }

    componentWillUnmount() {
        // Clean up version checker
        versionChecker.stopPeriodicCheck();
    }

    doLogout() {
        PORTAL_INSTANCE.authInst.logout()
        setTimeout(() => {
            if (this.isHomeCustomer) {
                this.redirectUrl(`/home-customer/login`);
            } else {
                this.redirectUrl(`/login`);
            }
        }, 300)
    }
    // redirect Login file
    redirectUrl = (urlName) => {
        const url = `${urlName}${this.props.location.search}`
        return this.props.navigate(url)
    }
    moveToLogin = (url) => {
        const urlName = `${url}${this.props.location.search}`
        return this.props.navigate(urlName)
    }
    render() {
        return (
            <Aux>
                <ScrollToTop>
                    <Suspense fallback={<LoadingSkeleton />}>
                        <Outlet />
                    </Suspense>
                </ScrollToTop>

                <WarningIssue item={{
                    title: 'Unauthorized Access', message: `You are trying to make Unauthorized Access into Customer Portal System.
                            Please Contact Admin if you are Customer Portal Active User.` }} show={this.props.notAllowedToEnter && this.state.showRequireLogin} onHide={() => { }} onNext={() => { this.setState({ showRequireLogin: false }); this.moveToLogin('/login'); }}></WarningIssue>
                <WarningIssue item={{
                    title: 'Unauthorized Access', message: `You are trying to make Unauthorized Access into Home Customer Portal System.
                            Please Contact Admin if you are Home Customer Portal Active User.` }} show={this.props.notAllowedToEnterHomeCustomerPortal} onHide={() => { }} onNext={() => { }}></WarningIssue>

                <WarningIssue item={{ title: t(`SessionExpired`), message: t(`SessionExpiredDesc`) }} show={this.state.showWarning} onHide={() => { }} onNext={() => { this.setState({ showWarning: false }) }}></WarningIssue>

                <ToastContainer autoClose={5000} position="bottom-center" theme='colored' style={{ "bottom": "0px" }} />
                <LoadingOverlay2 />
                <SupportButton floating={!this.isSignInRoute}/>
            </Aux>
        );
    }
}

export default withRouter(connect(mapStateProps, mapActionProps)(App));
